<template>
  <div class="mvc-detail">
    <template v-if="baseInfo.source == '闰土'">
      <el-button v-if="!isEdit" type="primary" @click="onEdit">编辑</el-button>
      <el-button v-else type="primary" @click="onSubmit">保存</el-button>
    </template>
    <el-button v-if="baseInfo.effective == '1'" type="danger" @click="onStatus(0)">禁用</el-button>
    <el-button v-else-if="baseInfo.effective == '0'" type="primary" @click="onStatus(1)">启用</el-button>
    <el-divider />
    <div class="base-info-box">
      <div class="title">基础信息</div>
      <el-row class="row">
        <el-col :span="12">
          <el-row class="row">
            <el-col class="col-title" :span="colTitleSpan">储值卡LOGO：</el-col>
            <el-col class="col-value" :span="colValueSpan">
              <el-image v-if="!isEdit" class="img-logo" :src="baseInfo.logo" fit="contain" alt="" />
              <UploadImg v-else name="logo" @getUploadFile="getUploadFile" :uploadUrl="baseInfo.logo" desc="建议：上传45x45的jpg、png、jpeg图片"></UploadImg>
            </el-col>
          </el-row>
          <el-row class="row">
            <el-col class="col-title" :span="colTitleSpan">储值卡名称：</el-col>
            <el-col class="col-value" :span="colValueSpan">{{ baseInfo.name }}</el-col>
          </el-row>
          <el-row class="row">
            <el-col class="col-title" :span="colTitleSpan">储值卡面值：</el-col>
            <el-col class="col-value" :span="colValueSpan">{{ baseInfo.amount }}元</el-col>
          </el-row>
          <!-- <el-row class="row">
            <el-col class="col-title" :span="colTitleSpan">储值卡售价：</el-col>
            <el-col class="col-value" :span="colValueSpan">{{ baseInfo.price }}元</el-col>
          </el-row> -->
          <el-row class="row">
            <el-col class="col-title" :span="colTitleSpan">可售数量：</el-col>
            <el-col class="col-value" :span="colValueSpan">{{ baseInfo.quantityLimit }}张</el-col>
          </el-row>
          <el-row class="row">
            <el-col class="col-title" :span="colTitleSpan">剩余数量：</el-col>
            <el-col class="col-value" :span="colValueSpan">{{ baseInfo.remainingQuantity }}张</el-col>
          </el-row>
          <el-row class="row">
            <el-col class="col-title" :span="colTitleSpan">商场分摊费用：</el-col>
            <el-col class="col-value" :span="colValueSpan">{{ baseInfo.mallCostAmount }}元</el-col>
          </el-row>
          <el-row class="row">
            <el-col class="col-title" :span="colTitleSpan">店铺分摊费用：</el-col>
            <el-col class="col-value" :span="colValueSpan">{{ baseInfo.storeCostAmount }}元</el-col>
          </el-row>
        </el-col>
        <el-col :span="12">
          <el-row class="row">
            <el-col class="col-title" :span="colTitleSpan">储值卡封面：</el-col>
            <el-col class="col-value" :span="colValueSpan">
              <template v-if="!isEdit">
                <el-image v-if="baseInfo.cover" class="img-cover" :src="baseInfo.cover" fit="contain" alt=""/>
                <div class="img-cover empty" v-else>---</div>
              </template>
              <UploadImg v-else name="cover" @getUploadFile="getUploadFile" :uploadUrl="baseInfo.cover" :width="300" desc="建议：上传345x120的jpg、png、jpeg图片"></UploadImg>
            </el-col>
          </el-row>
          <el-row class="row">
            <el-col class="col-title" :span="colTitleSpan">储值卡有效时间：</el-col>
            <el-col class="col-value" :span="colValueSpan">
              <span v-if="baseInfo.effectiveType == 'Fixed'">{{baseInfo.startTime}}至{{baseInfo.endTime}}</span>
              <span v-if="baseInfo.effectiveType == 'Unfixed'">购卡成功后{{baseInfo.effectiveMonth}}个月内有效</span>
            </el-col>
          </el-row>
          <el-row class="row">
            <el-col class="col-title" :span="colTitleSpan">使用范围：</el-col>
            <el-col class="col-value" :span="colValueSpan">{{ baseInfo.useRangeType }}</el-col>
          </el-row>
          <!-- <el-row class="row">
            <el-col class="col-title" :span="colTitleSpan">是否允许退款：</el-col>
            <el-col class="col-value" :span="colValueSpan">{{ baseInfo.allowRefund ? '允许' : '不允许' }}</el-col>
          </el-row> -->
          <el-row class="row">
            <el-col class="col-title" :span="colTitleSpan">状态：</el-col>
            <el-col class="col-value" :span="colValueSpan">{{ effectiveMap[baseInfo.effective] }}</el-col>
          </el-row>
          <el-row class="row">
            <el-col class="col-title" :span="colTitleSpan">使用规则：</el-col>
            <el-col class="col-value" :span="colValueSpan" style="line-height: 20px; margin-top: 15px;">
              <div class="rule-box">
                <span style="white-space: pre-line;">{{ baseInfo.rule }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row class="row">
            <el-col class="col-title" :span="colTitleSpan">结算类型：</el-col>
            <el-col class="col-value" :span="colValueSpan">{{settlementTypeMap[baseInfo.settlementType] || '---'}}</el-col>
          </el-row>
          <el-row class="row">
            <el-col class="col-title" :span="colTitleSpan">数据来源：</el-col>
            <el-col class="col-value" :span="colValueSpan">{{baseInfo.source || '---'}}</el-col>
          </el-row>
        </el-col>
      </el-row>
       <div class="title">券信息</div>
          <el-row class="row-info">
            <el-col :span="2" class="col-label">优惠券</el-col>
            <el-col :span="22" class="col-value">
              <div class="coupon-table" style="margin-left: 0;">
                <Table
                  :tableThData="tableThData_coupon"
                  :tableTrData="baseInfo.runtuGiftCoupon"
                  :pagination="false"
                >
                  <template #name="{ row }">{{ row.name }}</template>
                  <template #type="{ row }">{{ row.type }}</template>
                  <template #detail="{ row }">{{ row.detail }}</template>
                  <template #require="{ row }">{{ row.require }}</template>
                  <template #useTime="{ row }">{{ row.useTime }}</template>
                  <template #giveCoupnCount="{ row }">{{ row.giveCoupnCount }}</template>
                </Table>
              </div>
            </el-col>
          </el-row>
          <el-row class="row-info">
            <el-col :span="2" class="col-label">礼品券</el-col>
            <el-col :span="22" class="col-value">
              <div class="coupon-table" style="margin-left: 0;">
                <Table
                  :tableThData="tableThData_gift"
                  :tableTrData="baseInfo.giftGiftCoupon"
                  :pagination="false"
                >
                  <template #name="{ row }">{{ row.name }}</template>
                  <template #subTitle="{ row }">{{ row.subTitle }}</template>
                  <template #useTime="{ row }">{{ row.useTime }}</template>
                  <template #useRangeType="{ row }">{{ row.useRangeType }}</template>
                  <template #description="{ row }">
                    <el-button v-if="row.description" type="text" @click="onLookRemark(row)">查看使用须知</el-button>
                    <span v-else>---</span>
                  </template>
                  <template #giveCoupnCount="{ row }">{{ row.giveCoupnCount }}</template>
                </Table>
              </div>
            </el-col>
          </el-row>
          <el-row class="row-info">
            <el-col :span="2" class="col-label">停车券</el-col>
            <el-col :span="22" class="col-value">
              <div class="coupon-table" style="margin-left: 0;">
                <Table
                  :tableThData="tableThData_parking"
                  :tableTrData="baseInfo.lotGiftCoupon"
                  :pagination="false"
                >
                <template #name="{ row }">{{ row.name }}</template>
                <template #discount="{ row }">{{ row.discount }}</template>
                <template #mallName="{ row }">{{ row.mallName }}</template>
                <template #validTime="{ row }">{{ row.validTime }}</template>
                <template #remark="{ row }">
                  <el-button v-if="row.remark" type="text" @click="onLookRemark(row,'parking')">查看使用须知</el-button>
                  <span v-else>---</span>
                </template>
                  <template #giveCoupnCount="{ row }">{{ row.giveCoupnCount }}</template>
                </Table>
              </div>
            </el-col>
          </el-row>
          <el-dialog :visible="isShowRemarkDialog" title="使用须知" :before-close="() => this.isShowRemarkDialog = false" width="30%">
            <div class="remark-box" v-html="currentRow.description"></div>
          </el-dialog>
     </div>
    <div class="footer">
      <el-button @click="onBack">返回</el-button>
    </div>
  </div>
</template>

<script>
import UploadImg from '@/components/UploadImg/index'
import { api_getValueCardDetail, api_putValueCardStatus, api_putValueCardEdit } from '@/api/market'
import { api_postFileUpload } from '@/api/common'
import Table from "@/components/Table/index";
export default {
  name: "mvcDetail",
  components: {
    UploadImg,
    Table
  },
  data() {
    return {
      baseInfo: {}, // 基础信息数据
      colTitleSpan: 5,
      colValueSpan: 19,
      isShowRemarkDialog:false,
      currentRow:{},
      tableThData_coupon: [
        { prop: "name", label: "优惠券名称", minWidth: "120", },
        { prop: "type", label: "优惠券类型", minWidth: "120", },
        { prop: "detail", label: "券优惠", minWidth: "120", },
        { prop: "require", label: "券门槛", minWidth: "120", },
        { prop: "useTime", label: "用券时间", minWidth: "120", },
        { prop: "giveCoupnCount", label: "每人可赠数量", minWidth: "120",},
      ],
      tableThData_gift: [
        { prop: "name", label: "礼品券名称", minWidth: "120", },
        { prop: "subTitle", label: "标题", minWidth: "120", },
        { prop: "useTime", label: "券有效时间", minWidth: "120", },
        { prop: "useRangeType", label: "核销范围", minWidth: "120", },
        { prop: "description", label: "使用须知", minWidth: "120", },
        { prop: "giveCoupnCount", label: "每人可赠数量", minWidth: "120",},
      ],
      tableThData_parking: [
        { prop: "name", label: "停车券名称", minWidth: "120", },
        { prop: "discount", label: "抵扣优惠", minWidth: "120", },
        { prop: "validTime", label: "券有效时间", minWidth: "120", },
        { prop: "mallName", label: "使用范围", minWidth: "120", },
        { prop: "remark", label: "使用须知", minWidth: "120", },
        { prop: "giveCoupnCount", label: "每人可赠数量", minWidth: "120",},
      ],
      effectiveMap: {
        '0': '禁用',
        '1': '启用',
        '2': '已售罄',
      },
      settlementTypeMap: {
        'Settlement': '门店结算',
        'ReduceIncome': '门店减收',
      },
      form: {},
      isEdit: false,
    };
  },
  created() {},
  mounted() {
    this.getDetailData() // 获取详情数据
  },
  methods: {
    // 获取详情数据
    async getDetailData() {
      try {
        const res = await api_getValueCardDetail({id: this.$route.query.id})
        res.runtuGiftCoupon = res.giveCoupon&&res.giveCoupon.runtuGiftCoupon? res.giveCoupon.runtuGiftCoupon : [],
        res.giftGiftCoupon = res.giveCoupon&&res.giveCoupon.giftGiftCoupon ? res.giveCoupon.giftGiftCoupon : [],
        res.lotGiftCoupon = res.giveCoupon&&res.giveCoupon.lotGiftCoupon ? res.giveCoupon.lotGiftCoupon : []
        this.baseInfo = res

      } catch(err) {
        console.log('err: ', err);
      }
    },

    // 改变状态
    async onStatus(effective) {
      console.log(effective)
      this.$baseConfirm(
          `是否确认${effective ? '启用' : '禁用'}该储值卡？`,
          {
            title: '提示',
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            showClose: false,
            type: 'warning',
          },
          async () => {
            const res = await api_putValueCardStatus({
              id: this.$route.query.id,
              effective
            })
            this.$baseMessage('操作成功', 'success')
            console.log(res)
            this.getDetailData()
          }
        )
    },

    // 点击编辑
    onEdit() {
      this.$baseMessage('只可编辑 储值卡LOGO 和 储值卡封面', 'warning')
      this.isEdit = true
    },
     // 查看使用须知
    onLookRemark(row,type) {
      this.currentRow = row
      if(type == 'parking'){
        this.currentRow.description = row.remark
      }
      this.isShowRemarkDialog = true
    },
    // 点击保存
    async onSubmit() {
      console.log(this.form)
      let params = {
        id: this.$route.query.id
      }
      if (this.form.logo && this.form.logo.size) {
        const { key } = await api_postFileUpload(this.form.logo, 'CardLogo')
        params.logo = key
      }
      if (this.form.cover && this.form.cover.size) {
        const { key } = await api_postFileUpload(this.form.cover, 'CardCover')
        params.cover = key
      }
      await api_putValueCardEdit(params)
      this.isEdit = false
      this.getDetailData()
    },

    getUploadFile (file, name) {
      this.form[name] = file
    },

    // 返回
    onBack() {
      this.$router.back(-1)
    },
  },
  watch: {},
  computed: {},
};
</script>
<style lang="scss" scoped>
.mvc-detail {
  width: 100%;
  padding: 35px 20px;
  box-sizing: border-box;
  position: relative;
  padding-bottom: 100px;

  .img-logo {
    width: 150px;
    height: 150px;
    border: 1px solid #ccc;
  }

  .img-cover {
    width: 250px;
    height: 150px;
    border: 1px solid #ccc;

    &.empty {
      border: none;
      margin-bottom: 20px;
    }
  }
  .row-info {
    min-height: 34px;
    line-height: 34px;
    margin-bottom: 20px;
    font-size: 14px;

    .col-label {
      text-align: right;
      padding-right: 20px;
      color: #666;
    }

    .col-value {
      color: #000;
    }
  }
  .remark-box {
    width: 100%;
    min-height: 300px;
    max-height: 500px;
    overflow: auto;

    &::v-deep img {
      width: 100% !important;
    }
  }
  .coupon-table {
    width: 90%;
    margin-left: 130px;
    margin-bottom: 20px;

    .table-price-box {
      display: flex;

      .text {
        height: 34px;
        line-height: 34px;
        margin: 0 10px;
      }
    }
  }
  .row {
    min-height: 50px;
    line-height: 50px;
    font-size: 14px;
    color: #666666;

    .col-title {
      text-align: right;
    }

    .col-value {
      min-height: 50px;
      color: #333333;

      .rule-box {
        background-color: #F2F3F5;
        padding: 20px;
        color: #999;
        font-size: 14px;
        max-width: 400px;
        border-radius: 2px;
      }
    }
  }

  .el-divider {
    margin-top: 30px;
    margin-bottom: 20px;
  }

  .title {
    margin: 0;
    margin-bottom: 30px;
    padding-left: 15px;
    height: 25px;
    line-height: 25px;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    position: relative;

    .title-remark {
      color: #666666;
      font-size: 14px;
    }

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      content: '';
      width: 5px;
      height: 25px;
      border-radius: 2px;
      background: #05C8AF;
    }
  }

  .footer{
    position: fixed;
    bottom: 0;
    padding: 20px 0;
    padding-left: 70px;
    background: #fff;
    width: calc(100vw - #{$base-left-menu-width});
    left: $base-left-menu-width;
  }
}
</style>
